import { ConfigurationParameters, Product } from './../interfaces';
import { createRequestBuilder } from '@commercetools/api-request-builder';
import { makeCommerceToolsClient } from './makeCommercetoolsClient';
import { productTransformer } from './dataTransformers';

export async function fetchProducts(
  config: ConfigurationParameters
): Promise<Product[]> {
  const client = makeCommerceToolsClient({
    parameters: { installation: config },
  });
  const requestBuilder = createRequestBuilder({
    projectKey: config.projectKey,
  });

  const uri = requestBuilder.productProjectionsSearch.perPage(200).build();
  const response = await client.execute({ uri, method: 'GET' });
  if (response.statusCode === 200) {
    const products = response.body.results.map(productTransformer(config));
    return products;
  }
  throw new Error(response.statusCode);
}

export async function fetchProductsWithVariants(
  config: ConfigurationParameters
): Promise<Product[]> {
  const client = makeCommerceToolsClient({
    parameters: { installation: config },
  });
  const requestBuilder = createRequestBuilder({
    projectKey: config.projectKey,
  });

  const uri = requestBuilder.productProjectionsSearch.perPage(200).build();
  const response = await client.execute({ uri, method: 'GET' });
  if (response.statusCode === 200) {
    response.body.results.forEach((product) => {
      if (product.masterVariant) {
        product.variants.push(product.masterVariant);
      }
    });

    const filterVariantProducts = response.body.results.filter((product) => {
      if (product.variants && product.variants.length) {
        return true;
      }
      return false;
    });

    const products = filterVariantProducts.map(productTransformer(config));
    return products;
  }
  throw new Error(response.statusCode);
}
